import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, SelectChangeEvent, Stack, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { drainEfficiency, hasSeismicLoads, horizontalSeismicLoad, loadPD, minFsSeismicConditions, minFsStaticConditions, verticalSeismicLoad } from '../../conversion/load';
import inputRangeLoad from '../../inputRange/load';
import { cleanImage } from '../../store/Image/imageSlice';
import { cleanAlert } from '../../store/alert/alertSlice';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { selectProject, setLoad } from '../../store/project/projectSlice';
import { cleanResult } from '../../store/result/resultSlice';
import Input from '../component/Input';
import Switch from '../component/Switch';
import { IInputLoad, TInputLoad } from '../iProject';
import { getInputLoad } from './util';

interface IInputLoadProps {}

const InputLoad = (props: IInputLoadProps) => {
    const project = useAppSelector(selectProject);
    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    let timer = React.useRef<NodeJS.Timeout>();

    let input = getInputLoad(project.data?.load!);

    const formik = useFormik<IInputLoad>({
        initialValues: input,
        onSubmit: values => {},
    });

    const handleChange = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let { name, value, type, checked } = event.target;
        let isAvailableValue = true;
        if (type == 'checkbox') {
            value = checked;
        } else {
            value = parseFloat(value);
            isAvailableValue = !isNaN(value);
        }
        let updateValue = { [name]: value };
        if (isAvailableValue) {
            let payload: IInputLoad = { ...formik.values, ...updateValue };
            setValues(payload);
            dispatch(cleanResult());
            dispatch(cleanImage());
            dispatch(cleanAlert());
        }
    };

    const setValues = (payload: IInputLoad) => {
        formik.setValues(payload);
        dispatch(setLoad({ ...project.data?.load, ...payload }));
    };

    const handleHidden = (name: string) => {
        if (name == horizontalSeismicLoad || name == verticalSeismicLoad || name == minFsSeismicConditions) return !formik.values.hasSeismicLoads;
        return false;
    };

    const handleDisabled = (name: string) => {
        return false;
    };

    const handleTextTooltip = (name: string) => {
        if (name == drainEfficiency) return t('drainEfficiencyInfobox');
    };

    return (
        <Accordion disableGutters>
            <AccordionSummary variant='standard' expandIcon={<ExpandMoreIcon />} aria-controls='panel3a-content' id='panel3a-header'>
                <Typography>{t('loadInput')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {Object.keys(formik.values).map((x, i) => {
                    let sectionEl;
                    if (x === hasSeismicLoads) {
                        sectionEl = <Stack variant='bottomLineTextGreen'>{t('loadInputSeismicSection')}</Stack>;
                        return (
                            <Stack key={`${x}_${i}`}>
                                <Switch defaultChecked={formik.values[x as TInputLoad] as boolean} onChange={handleChange} name={x} label={t(x)} />
                                {(formik.values[x as TInputLoad] as boolean) && sectionEl}
                            </Stack>
                        );
                    } else {
                        if (x == minFsStaticConditions) sectionEl = <Stack variant='bottomLineTextGreen'>{t('loadInputSafetySection')}</Stack>;
                        return (
                            <Stack key={`${x}_${i}`}>
                                {sectionEl}
                                <Input
                                    hidden={handleHidden(x)}
                                    disabled={handleDisabled(x)}
                                    value={formik.values[x as TInputLoad]}
                                    minValue={inputRangeLoad[x]?.min.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!]}
                                    maxValue={inputRangeLoad[x]?.max.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!]}
                                    id={x}
                                    isNumber={typeof formik.values[x as TInputLoad] == 'number'}
                                    label={t(x, { unitOfMeasure: loadPD[x as TInputLoad]?.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!] })}
                                    name={x}
                                    onChange={handleChange}
                                    textTooltip={handleTextTooltip(x as TInputLoad)}
                                />
                            </Stack>
                        );
                    }
                })}
            </AccordionDetails>
        </Accordion>
    );
};

export default InputLoad;
